import React from "react";

import { Grid, Typography } from "@mui/material";

export const FrameConfirmation = () => {
  // @ts-expect-error this page will always be embedded
  window.top.postMessage("done", "*");

  return (
    <Grid
      container
      item
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ flex: 1, height: "100vh" }}
    >
      <img
        src="/static/img/CheckCircle.svg"
        alt=""
        style={{ height: "100px" }}
      />
      <Typography color="primary.main" variant="h2">
        Concluído
      </Typography>
    </Grid>
  );
};
